import { Modal } from "ant-design-vue"

/**
 * Уведомления
 */
export default {
	install(Vue) {
		Vue.prototype.$dialog = {
			confirm: params => Modal.confirm(params)
		}
	}
}
